var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { active: _vm.isActive },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Item No.")]),
        _vm.value.isNew
          ? _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control short-width" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.itemNo,
                      expression: "value.itemNo",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "input is-capitalized",
                  class: { "is-danger": _vm.$v.entity.itemNo.$error },
                  attrs: {
                    name: "itemNo",
                    type: "text",
                    placeholder: "Item No",
                    maxlength: "5",
                  },
                  domProps: { value: _vm.value.itemNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "itemNo", $event.target.value)
                    },
                  },
                }),
                _vm.$v.entity && !_vm.$v.entity.itemNo.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Item No. is required"),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v(_vm._s(_vm.value.itemNo))]),
            ]),
      ]),
      _vm.value.isNew
        ? _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Item Type ")]),
              _c("span", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.itemType,
                        expression: "value.itemType",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "itemType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function ($event) {
                          return _vm.onChangeItemType($event)
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: { selected: "" },
                        domProps: { value: _vm.itemTypeEnum.LABOUR },
                      },
                      [_vm._v("Labour")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.PARTS } },
                      [_vm._v("Parts")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.OPG } },
                      [_vm._v("OPG")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.MISC } },
                      [_vm._v("Misc")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.SUBL } },
                      [_vm._v("Sublet")]
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Item Type ")]),
            _c("span", [_vm._v("Labour")]),
          ]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Butterfly")]),
        _c(
          "div",
          { staticClass: "control is-expanded butterfly-width" },
          [
            _c(
              "multiselect",
              {
                attrs: {
                  "deselect-label": "Can't remove this value",
                  "track-by": "butterflyCode",
                  label: "description",
                  options: _vm.butterflies,
                  loading: _vm.isButterflyLoading,
                  "internal-search": false,
                  "options-limit": _vm.butterflyFilter.pageSize,
                  searchable: true,
                  "show-labels": false,
                  "allow-empty": true,
                },
                on: {
                  select: _vm.selectButterfly,
                  remove: _vm.removeButterfly,
                  "search-change": _vm.getButterflyDropdownFilter,
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function (props) {
                      return [
                        _c("span", [_vm._v(_vm._s(props.option.description))]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedButterfly,
                  callback: function ($$v) {
                    _vm.selectedButterfly = $$v
                  },
                  expression: "selectedButterfly",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "has-text-danger",
                    attrs: { slot: "noResult" },
                    slot: "noResult",
                  },
                  [_vm._v("Butterfly not found.")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Description")]),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "control desc-width" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.itemDesc,
                  expression: "value.itemDesc",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.$v.entity.itemDesc.$error },
              attrs: {
                name: "itemDesc",
                type: "text",
                placeholder: "Description",
                maxlength: "100",
              },
              domProps: { value: _vm.value.itemDesc },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "itemDesc", $event.target.value)
                },
              },
            }),
            _vm.$v.entity && !_vm.$v.entity.itemDesc.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Description is required"),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Sort Number")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("vue-numeric", {
                  staticClass: "input has-text-right",
                  attrs: { precision: 0, maxlength: "5" },
                  model: {
                    value: _vm.value.sortNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "sortNo", _vm._n($$v))
                    },
                    expression: "value.sortNo",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control is-narrow" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Allow Tick")]),
          _vm.isLabourTypeVisible("RR")
            ? _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.rrCheck,
                      expression: "value.rrCheck",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: { type: "checkbox", id: "rrCheck" },
                  domProps: {
                    checked: Array.isArray(_vm.value.rrCheck)
                      ? _vm._i(_vm.value.rrCheck, null) > -1
                      : _vm.value.rrCheck,
                  },
                  on: {
                    click: function ($event) {
                      _vm.value.rrCheck = !_vm.value.rrCheck
                    },
                    change: function ($event) {
                      var $$a = _vm.value.rrCheck,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.value, "rrCheck", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.value,
                              "rrCheck",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.value, "rrCheck", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "rrCheck" } }, [_vm._v("RR")]),
              ])
            : _vm._e(),
          _vm.isLabourTypeVisible("RWA")
            ? _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.rwaCheck,
                      expression: "value.rwaCheck",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: { type: "checkbox", id: "rwaCheck" },
                  domProps: {
                    checked: Array.isArray(_vm.value.rwaCheck)
                      ? _vm._i(_vm.value.rwaCheck, null) > -1
                      : _vm.value.rwaCheck,
                  },
                  on: {
                    click: function ($event) {
                      _vm.value.rwaCheck = !_vm.value.rwaCheck
                    },
                    change: function ($event) {
                      var $$a = _vm.value.rwaCheck,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.value, "rwaCheck", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.value,
                              "rwaCheck",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.value, "rwaCheck", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "rwaCheck" } }, [_vm._v("RWA")]),
              ])
            : _vm._e(),
          _vm.isLabourTypeVisible("REP")
            ? _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.repairCheck,
                      expression: "value.repairCheck",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: { type: "checkbox", id: "repairCheck" },
                  domProps: {
                    checked: Array.isArray(_vm.value.repairCheck)
                      ? _vm._i(_vm.value.repairCheck, null) > -1
                      : _vm.value.repairCheck,
                  },
                  on: {
                    click: function ($event) {
                      _vm.value.repairCheck = !_vm.value.repairCheck
                    },
                    change: function ($event) {
                      var $$a = _vm.value.repairCheck,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.value,
                              "repairCheck",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.value,
                              "repairCheck",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.value, "repairCheck", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "repairCheck" } }, [
                  _vm._v("Repair"),
                ]),
              ])
            : _vm._e(),
          _vm.isLabourTypeVisible("PAINT")
            ? _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.paintCheck,
                      expression: "value.paintCheck",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: { type: "checkbox", id: "paintCheck" },
                  domProps: {
                    checked: Array.isArray(_vm.value.paintCheck)
                      ? _vm._i(_vm.value.paintCheck, null) > -1
                      : _vm.value.paintCheck,
                  },
                  on: {
                    click: function ($event) {
                      _vm.value.paintCheck = !_vm.value.paintCheck
                    },
                    change: function ($event) {
                      var $$a = _vm.value.paintCheck,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.value, "paintCheck", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.value,
                              "paintCheck",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.value, "paintCheck", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "paintCheck" } }, [
                  _vm._v("Paint"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value.rrCheck && _vm.isLabourTypeVisible("RR"),
                expression: "value.rrCheck && isLabourTypeVisible('RR')",
              },
            ],
            staticClass: "field-body",
          },
          [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("RR Hour")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0.0, precision: 2 },
                    model: {
                      value: _vm.value.rrHour,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "rrHour", _vm._n($$v))
                      },
                      expression: "value.rrHour",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value.rwaCheck && _vm.isLabourTypeVisible("RWA"),
                expression: "value.rwaCheck && isLabourTypeVisible('RWA')",
              },
            ],
            staticClass: "field-body",
          },
          [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("RWA Hour")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0.0, precision: 2 },
                    model: {
                      value: _vm.value.rwa,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "rwa", _vm._n($$v))
                      },
                      expression: "value.rwa",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value.repairCheck && _vm.isLabourTypeVisible("REP"),
                expression: "value.repairCheck && isLabourTypeVisible('REP')",
              },
            ],
            staticClass: "field-body",
          },
          [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Repair Hour")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0.0, precision: 2 },
                    model: {
                      value: _vm.value.repairHour,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "repairHour", _vm._n($$v))
                      },
                      expression: "value.repairHour",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value.paintCheck && _vm.isLabourTypeVisible("PAINT"),
                expression: "value.paintCheck && isLabourTypeVisible('PAINT')",
              },
            ],
            staticClass: "field-body",
          },
          [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Paint Hour")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("vue-numeric", {
                    staticClass: "input has-text-right",
                    attrs: { min: 0.0, precision: 2 },
                    model: {
                      value: _vm.value.paintHour,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "paintHour", _vm._n($$v))
                      },
                      expression: "value.paintHour",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }